import React, { useEffect } from "react";
import MapContainer from './components/Map/MapContainer';
import './styles.css';
import 'leaflet/dist/leaflet.css'; // Import Leaflet CSS
import L from 'leaflet';

// Fix Leaflet's default icon path issues with webpack/create-react-app
function fixLeafletIcons() {
  delete (L.Icon.Default.prototype as any)._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });
}

function App() {
  useEffect(() => {
    fixLeafletIcons();
  }, []);

  return (
    <div className="app">
      <MapContainer />
    </div>
  );
}

export default App;

